import React from 'react'

export const IconFilters = (props= {}) => {
	const { size= 20, imgSize= 20, fill="white" } = props
	return (
		<svg xmlns="http://www.w3.org/2000/svg"
				 width={`${size}px`}
				 height={`${size}px`}
				 viewBox={`0 0 ${imgSize} ${imgSize}`}
				 fill="none"
		>
			<path fillRule="evenodd" clipRule="evenodd"
						d="M1.90039 4.3999H18.1004V5.5999H1.90039V4.3999ZM5.23372 9.3999H14.7671V10.5999H5.23372V9.3999ZM7.73372 14.3999H12.2671V15.5999H7.73372V14.3999Z"
						fill={fill}
			/>
		</svg>
	)
}